// startup
// Load entry module
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./ts/index.ts");
